import { ReactNode } from 'react';

import { Flex, Text } from '@spotify-internal/encore-web';

import styles from './KeyValueRow.module.css';

interface KeyValueRowProps {
  label: string;
  children: ReactNode;
}

export const KeyValueRow = ({ label, children }: KeyValueRowProps) => (
  <Flex alignItems="center" gap="tighter-2">
    <Text className={styles.label} variant="bodySmall">
      {label}
    </Text>
    <Flex alignItems="center" wrap="wrap" gap="tighter-2">
      {children}
    </Flex>
  </Flex>
);
